import { CountryCode } from '../countryCodes'

const messages: IMessage | any = {
  /* eslint-disable @typescript-eslint/camelcase */
  bg: 'Собствено съобщение',
  cz: 'Vlastní zpráva',
  de: 'Eigene Nachricht',
  el: 'Το δικό σας μήνυμα',
  en: 'Own message',
  es: 'Mensaje propio',
  fil: 'Sariling mensahe',
  fr: 'Propre message',
  hr: 'Vlastita poruka',
  hu: 'Saját üzenet',
  in: 'Pesan sendiri',
  it: 'Proprio messaggio',
  ja: '自分のメッセージ',
  ko: '자신의 메시지',
  ms: 'Mesej sendiri',
  pl: 'Zwykła wiadomość',
  pl_PL: 'Zwykła wiadomość',
  pt: 'Mensagem própria',
  pt_BR: 'Mensagem própria',
  ro: 'Mesaj propriu',
  ru: 'Собственное сообщение',
  se: 'Eget meddelande',
  th: 'ข้อความของตัวเอง',
  tr: 'Kendi mesajım',
  uk: 'Власне повідомлення',
  /* eslint-enable */
}

export default function(lng: CountryCode): string {
  return messages[lng]
}

type IMessage = { [key in CountryCode]?: string }
